import { createSlice } from "@reduxjs/toolkit";

const initialStockTransferListState = {
  stockTransfers: [],
  stockTransfersTotalCount: 0,
  listLoading: false,
  actionsLoading: false,
  stockTransferEntities: null,
  statusChanged: false,
  filter: {
    status: null,
    startDate: null,
    endDate: null,
  },
  message: {
    error: null,
    success: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const stockTransferListSlice = createSlice({
  name: "stockTransferList",
  initialState: initialStockTransferListState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // change order status
    changeStockTransferStatus: (state, action) => {
      state.error = null;
      state.statusChanged = true;
      state.actionsLoading = false;
      const { order } = action.payload;
      state.stockTransfers = state.stockTransfers.map((entity) => {
        if (order.id === entity.id) {
          entity = order;
        }
        return entity;
      });
    },

    stockTransferFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.error = null;
      state.actionsLoading = false;
      state.stockTransfers = entities;
      state.stockTransfersTotalCount = totalCount;
      state.listLoading = false;
    },

    //order search started-----------
    // getOrders
    findStockTransferByNo: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.stockTransferEntities = entities;
    },

    //deselect supplier selected for order
    removeFilterOrder: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.filter.order = null;
    },
    // addSupplier
    selectFilterOrder: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.filter.order = action.payload.order;
      state.stockTransferEntities = null;
    },
    //order search ended

    // delete Order
    deleteStockTransfer: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { id, message } = action.payload;
      state.stockTransfers = state.stockTransfers.filter((order) => order.id !== Number(id));
      state.message.success = message;
    },
    selectFilterStatus: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { status } = action.payload;
      state.filter.status = status == 0 ? null : status;
    },
    selectFilterDate: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { date } = action.payload;
      if (date != null) {
        state.filter.startDate = date[0];
        state.filter.endDate = date[1];
      } else {
        state.filter.startDate = null;
        state.filter.endDate = null;
      }
    },
    statusChanged: (state, action) => {
      state.statusChanged = action.payload.statusChanged;
    },
    resetState: (state, action) => {
      state.stockTransfers = null;
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
  },
});
